module.exports = __webpack_public_path__ + "assets/img/fcac93af934aba7cc52edf8bd445a9b7.svg";